import React from "react";
import { connect } from "react-redux";

import withStyles from "@material-ui/styles/withStyles";

import {
  Edit,
  FormDataConsumer,
  FormCard,
  ArrayInput,
  MultiCardForm,
  SimpleFormIterator,
  BooleanInput,
  ReferenceInput,
  ReferenceArrayInput,
  AutoCompleteArrayInput,
  SelectArrayInput,
  SelectInput,
  AutoCompleteInput,
  TextInput,
  required,
  RestMethods
} from "jazasoft";

import { dataProvider } from "../../App";

const inputOptions = sm => ({
  xs: 12,
  sm,
  fullWidth: true,
  options: { fullWidth: true }
});

const createStyle = theme => ({
  booleanInput: {
    display: "flex",
    alignItems: "center"
  }
});

class RoleEdit extends React.Component {
  state = {
    config: {}
  };

  componentDidMount() {
    this.fetchConfigAsync();
  }

  fetchConfigAsync = async () => {
    const options = {
      url: "permissions/configs",
      method: "get"
    };
    try {
      const response = await dataProvider(RestMethods.CUSTOM, null, options);
      this.setState({ config: response.data });
    } catch (e) {
      console.log(e);
    }
  };

  onChange = (values, dispatch, props, prevValues) => {
    if (values.appId !== prevValues.appId || values.tenantId !== prevValues.tenantId) {
      dispatch(props.change("permissionList", []));
    }
  };

  render() {
    const { classes, formData = {}, resources, apps, tenants, dispatch, ...props } = this.props;
    const config = this.state.config || {};
    const app = apps && formData.appId && apps[formData.appId];
    const tenant = tenants && formData.tenantId && tenants[formData.tenantId];
    let permissionList = (app && tenant && config[app.appId]) || [];
    const permissionKeys = permissionList.filter(p => p.type === "PER_ROLE");
    return (
      <Edit
        cardWrapper={false}
        format={(record = {}) => ({
          ...record,
          permissions: record?.permissionList ? record.permissionList.map((p) => p.id) : [],
          resources: record?.resourceList
            ? record.resourceList
                .sort((a, b) => (a.resourceName < b.resourceName ? -1 : 1))
                .map((r) => ({
                  ...r,
                  scopes: r.scopes ? r.scopes.split(",") : [],
                  actions: r.actions ? r.actions.split(",") : [],
                }))
            : [],
        })}
        {...props}
      >
        <MultiCardForm onChange={this.onChange}>
          <FormCard title="Basic Info" className={classes.form} redirect="home">
            <TextInput source="name" validate={[required()]} {...inputOptions(3)} />
            <TextInput label="Role Id" source="roleId" validate={[required()]} {...inputOptions(3)} />
            <ReferenceInput source="appId" reference="apps" {...inputOptions(3)}>
              <SelectInput />
            </ReferenceInput>
            <ReferenceInput source="tenantId" reference="tenants" {...inputOptions(3)}>
              <SelectInput />
            </ReferenceInput>
            <TextInput source="desc" {...inputOptions(3)} />

            {permissionKeys.map((p, idx) => (
              <ReferenceArrayInput
                key={`${p.key}-${app.id}-${tenant.id}`}
                label={p.name}
                source="permissions"
                reference="permissions"
                filter={{
                  "app.id": app.id,
                  "tenant.id": tenant.id,
                  key: p.key
                }}
                {...inputOptions(6)}
              >
                <AutoCompleteArrayInput />
              </ReferenceArrayInput>
            ))}
            <BooleanInput source="isDefault" formClassName={classes.booleanInput} xs={12} sm={3} />
          </FormCard>

          <FormCard title="Privilege">
            <ArrayInput source="resources" fullWidth={true} xs={12}>
              <SimpleFormIterator>
                <ReferenceInput
                  label="Resource"
                  source="resourceId"
                  reference="resources"
                  filter={{
                    "app.id": app ? app.id : null
                  }}
                >
                  <AutoCompleteInput />
                </ReferenceInput>

                <FormDataConsumer xs={12} sm={4}>
                  {({ formData, source }) => {
                    let idx = source && source.split(".")[0].substring(10);
                    idx = idx.substring(0, idx.length - 1);
                    const resourceId = formData.resources && formData.resources[idx] && formData.resources[idx].resourceId;
                    const resource = resources[resourceId];
                    return (
                      <SelectArrayInput
                        label="Scopes"
                        source={`${source.split(".")[0]}.scopes`}
                        choices={resource && resource.scopes ? resource.scopes.split(",").map((scope) => ({ id: scope, name: scope })) : []}
                        fullWidth
                        options={{ fullWidth: true }}
                      />
                    );
                  }}
                </FormDataConsumer>

                <FormDataConsumer xs={12} sm={4}>
                  {({ formData, source }) => {
                    let idx = source && source.split(".")[0].substring(10);
                    idx = idx.substring(0, idx.length - 1);
                    const resourceId = formData.resources && formData.resources[idx] && formData.resources[idx].resourceId;
                    const resource = resources[resourceId];
                    return (
                      <SelectArrayInput
                        label="Actions"
                        source={`${source.split(".")[0]}.actions`}
                        choices={
                          resource && resource.actions && resource.actions.trim().length > 0
                            ? resource.actions.split(",").map((action) => ({ id: action, name: action }))
                            : []
                        }
                        fullWidth
                        options={{ fullWidth: true }}
                      />
                    );
                  }}
                </FormDataConsumer>
              </SimpleFormIterator>
            </ArrayInput>
          </FormCard>
        </MultiCardForm>
      </Edit>
    );
  }
}

const mapStateToProps = (state) => ({
  resources: state.jazasoft.resources["resources"] && state.jazasoft.resources["resources"].data,
  apps: state.jazasoft.resources["apps"] && state.jazasoft.resources["apps"].data,
  tenants: state.jazasoft.resources["tenants"] && state.jazasoft.resources["tenants"].data,
  formData: state.form && state.form["record-form"] && state.form["record-form"].values,
});
export default connect(mapStateToProps)(withStyles(createStyle)(RoleEdit));
